import React, { useEffect, useState } from 'react';
import { TextField, Typography, CircularProgress } from '@mui/material';
import { useFeathers } from '../../app/util';

const BallotTextInput = ({
  value,
  onChange,
  boundingDistrict, // required for entity-match service
  style
}) => {
  const feathers = useFeathers();
  const [loadingTimestamps, setLoadingTimestamps] = useState([]);
  const [queuedResult, setQueuedResult] = useState(null);
  const [loading, setLoading] = useState(false);

  // Call entity-match service when value changes
  useEffect(() => {
    const matchEntity = async () => {
      if (!value || !boundingDistrict || !feathers) return;
      if(value.trim() === '') {
        return;
      }
      setLoading(true);

      const timestamp = Date.now();
      setLoadingTimestamps(l => [...l, timestamp]);

      try {
        const result = await feathers.getService('entity-match').create({
          type: 'positions',
          inputText: value,
          boundingDistrict: boundingDistrict
        });

        setQueuedResult({
          timestamp,
          result
        });
      } catch (error) {
        setLoading(false);
        console.error('Error matching entity:', error);
      }
    };

    matchEntity();
  }, [value, boundingDistrict, feathers]);

  // Process queued results, only applying the most recent one
  useEffect(() => {
    if (queuedResult) {
      setQueuedResult(null);

      const mostRecentTimestamp = loadingTimestamps[loadingTimestamps.length - 1];
      const isMostRecentResult = mostRecentTimestamp === queuedResult.timestamp;
      if (!isMostRecentResult) return;

      const { result } = queuedResult;
      if (result?.data?.length > 0) {
        const entry = result.data[0];
        const { district, office, position } = entry;

        console.log('district', district);

        onChange({
          ballotText: value,
          district: district?.district,
          office: office?.office,
          positionData: position,
        });
        setLoading(false);
      }
    }
  }, [queuedResult, loadingTimestamps, value]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <TextField
        value={value}
        onChange={(e) => onChange({ ballotText: e.target.value })}
        variant='outlined'
        style={{
          border: 'solid 1px #EEEEEE',
          borderRadius: '8px',
          flexGrow: 1,
          ...style
        }}
        size='small'
      />
      {
        loading
        ? <div style={{ display: 'flex', alignItems: 'center', height: '100%', gap: '4px' }}>
            <CircularProgress size={15} />
            <Typography variant='body2' style={{ color: '#666666', fontSize: '12px' }}> Auto-matching...</Typography>
          </div>
        : <Typography variant='body2' style={{ color: '#666666', fontSize: '12px' }}>  </Typography>
      }
    </div>
  );
};

export { BallotTextInput }; 